// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isClient, getViewportInfo, setSessionStorage } from '@tcp/core/src/utils';
import { IMG_DATA_PLP_CAT_FILTERS } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/config';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import AnchorNew from '@tcp/core/src/components/common/atoms/Anchor/views/AnchorNew';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import { checkForCertainL1s } from '@tcp/core/src/components/features/browse/ProductListing/container/PlpCarousel.utils.js';
import withStyles from '../../../hoc/withStyles';
import styles from '../styles/L3NavigationCarousel.style';
import { processPath } from '../../../../../utils';
import { breakpoints } from '../../Accessories/container/Accessories.constants';
import Carousel from '../../Carousel';
import Button from '../../../atoms/Button';
import {
  getCarouselConfigArray,
  getCarouselConfigResponsiveArray,
  getSlidesToShow,
} from './L3NavCarouselHelper';

const { isDesktop } = getViewportInfo() || {};
export class L3NavigationCarousel extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    categoryFilters: PropTypes.shape(
      PropTypes.arrayOf(
        PropTypes.oneOfType(
          PropTypes.shape({
            image: PropTypes.shape({}),
            link: PropTypes.shape({}),
          })
        )
      )
    ).isRequired,
    asPath: PropTypes.string.isRequired,
    showCarousel: PropTypes.bool,
    variation: PropTypes.string,
    carouselTitle: PropTypes.string,
    showPLPGenericCarousel: PropTypes.bool,
    trackHorizontalPlpAnalytic: PropTypes.func,
    isPromoForMobile: PropTypes.bool,
    isGenericSBCRedesignEnabled: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    showCarousel: false,
    variation: '',
    carouselTitle: '',
    showPLPGenericCarousel: false,
    trackHorizontalPlpAnalytic: () => {},
    isPromoForMobile: false,
    isGenericSBCRedesignEnabled: false,
  };

  constructor(props) {
    super(props);
    this.promoFilter = React.createRef();
    this.activeSlideRef = React.createRef();
    this.sbcWrappperRef = React.createRef();
    this.carouselRef = React.createRef();
    this.state = {
      isSsrDone: false,
    };
  }

  componentDidMount() {
    const { showPLPGenericCarousel, asPath, categoryFilters } = this.props;
    if (showPLPGenericCarousel && !isDesktop) {
      this.scrollToElement();
    } else {
      const pageAsPathWithoutQuery = asPath.split('?')[0];
      let indexofSelected;
      categoryFilters.forEach(({ linkAspath }, index) => {
        if (`/c/${pageAsPathWithoutQuery}` === linkAspath) {
          indexofSelected = index;
        }
      });
      this.carouselRef?.current?.slickGoTo(indexofSelected);
    }

    this.setState({
      isSsrDone: true,
    });
    this.setSlickListWidth();
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return;
    const { isSbcContentChanged } = this.props;
    this.scrollElement(prevProps);
    if (isSbcContentChanged) {
      if (this.carouselRef?.current) {
        this.carouselRef?.current?.slickGoTo(0);
      }
      if (this.sbcWrappperRef.current) {
        this.sbcWrappperRef.current.scrollLeft = 0;
      }
    }
    this.setSlickListWidth();
  }

  scrollElement = (prevProps) => {
    const {
      showPLPGenericCarousel,
      asPath,
      categoryFilters,
      catLevel,
      plpSbc,
      isNewSBCImplementationEnabled,
    } = this.props;
    const shouldResetFocus =
      prevProps.asPath !== asPath || prevProps?.categoryFilters?.length !== categoryFilters?.length;
    if (prevProps.catLevel !== catLevel && isNewSBCImplementationEnabled) {
      if (!plpSbc && catLevel === 1) {
        this.carouselRef?.current?.slickGoTo(0);
      }
      if (showPLPGenericCarousel && shouldResetFocus && !isDesktop) {
        this.scrollToElement();
      }
    } else if (showPLPGenericCarousel && shouldResetFocus && !isDesktop) {
      this.scrollToElement();
    }
  };

  scrollToElement = () => {
    const viewportObj = isClient() && getViewportInfo();
    if (!viewportObj?.isDesktop) {
      const activeLeft = this.activeSlideRef?.current?.offsetLeft;
      const activeWidth = this.activeSlideRef?.current?.clientWidth;
      const crrentRef = this.sbcWrappperRef?.current;
      if (crrentRef && activeLeft && activeWidth) {
        crrentRef.scrollLeft =
          activeLeft - crrentRef?.offsetLeft - crrentRef?.clientWidth / 2 + activeWidth / 2;
      }
    }
  };

  trackAnalyticImg = (index, path) => {
    const clickedItemCid = path?.replace('/c/', '');
    setSessionStorage({ key: 'carouselItem', value: `s${index + 1}_${clickedItemCid}` });
  };

  setSlickListWidth = () => {
    const { isGenericSBCRedesignEnabled } = this.props;
    if (!isGenericSBCRedesignEnabled || !isClient()) return;
    const viewportObj = getViewportInfo();
    if (!viewportObj?.isDesktop) return;

    let slickList = document.querySelector('.sbc-redesign .sbc-plp  .slick-list');
    if (!slickList) return;
    const { categoryFilters } = this.props;
    let slickTrack = document.querySelector('.sbc-redesign .sbc-plp  .slick-track');
    if (slickList && slickTrack && categoryFilters?.length) {
      const slickListWidth = slickList.offsetWidth;
      const slickTrackWidth = slickTrack.offsetWidth;
      const newLength = categoryFilters.length * 180;
      if (slickListWidth === newLength) return;
      if (slickTrackWidth - slickListWidth < 50) {
        slickList.setAttribute('style', `width:${newLength}px !important`);
        slickList.style.margin = 'auto';
      } else {
        slickList.setAttribute('style', `width:100% !important`);
      }
    }
    slickList = null;
    slickTrack = null;
  };

  renderItems = (categoryFilters, className, itemClassName, pageAsPath) => {
    const { isGenericSBCRedesignEnabled } = this.props;
    const pageAsPathWithoutQuery = pageAsPath.split('?')[0];
    return (
      categoryFilters &&
      categoryFilters.map(({ url, title, filterTitle, linkUrl, linkAspath }, index) => {
        const toPath = linkUrl;
        const asPath = `${linkAspath}?viaModule=promoFilter`;
        const slideClass = 'image-container';
        let itemProps = {
          className: isGenericSBCRedesignEnabled ? 'tile-container' : itemClassName,
        };
        let isSelected = false;
        if (`/c/${pageAsPathWithoutQuery}` === linkAspath) {
          isSelected = true;
          itemProps = {
            className: `${
              isGenericSBCRedesignEnabled ? 'tile-container' : itemClassName
            } selected-filter`,
          };
        }
        return (
          <div key={filterTitle} {...itemProps}>
            <Anchor
              className="image-link"
              to={processPath(toPath, 'to')}
              asPath={processPath(asPath, 'path')}
              onClick={() => {
                this.trackAnalyticImg(index, linkAspath);
              }}
            >
              <div className={slideClass}>
                <DamImage
                  className={`${className} carousel-image`}
                  imgConfigs={IMG_DATA_PLP_CAT_FILTERS.imgConfig}
                  imgData={{
                    alt: title,
                    url,
                  }}
                />
              </div>
            </Anchor>

            <div className={`${isGenericSBCRedesignEnabled ? 'image-link' : 'title-container'}`}>
              <Anchor to={processPath(toPath, 'to')} asPath={processPath(asPath, 'path')}>
                <BodyCopy
                  fontSize="fs12"
                  fontFamily="secondary"
                  textAlign="center"
                  color={isSelected ? 'black' : 'gray.1900'}
                  fontWeight={isSelected ? 'bold' : 'regular'}
                  className="multiline-ellipsis"
                >
                  {filterTitle}
                </BodyCopy>
              </Anchor>
            </div>
          </div>
        );
      })
    );
  };

  renderPlpGenericCarouselItems = (categoryFilters, className, itemClassName, pageAsPath) => {
    const pageAsPathWithoutQuery = pageAsPath.split('?')[0];
    return (
      categoryFilters &&
      categoryFilters.map(({ url, title, filterTitle, linkUrl, linkAspath }, index) => {
        const toPath = linkUrl;
        const asPath = `${linkAspath}?viaModule=promoFilter`;
        const slideClass = 'image-container-new img-reactangle';
        let itemProps = { className: itemClassName };
        if (`/c/${pageAsPathWithoutQuery}` === linkAspath) {
          itemProps = { className: `${itemClassName} selected-filter-new`, hasRef: true };
        }
        return (
          <div key={filterTitle} ref={itemProps?.hasRef ? this.activeSlideRef : null}>
            <AnchorNew
              to={processPath(toPath, 'to')}
              asPath={processPath(asPath, 'path')}
              onClick={() => {
                this.trackAnalyticImg(index, linkAspath);
              }}
            >
              <div className={`sbc-main ${itemProps?.className}`}>
                <div className={slideClass}>
                  <AnchorNew
                    className="image-link-new"
                    to={processPath(toPath, 'to')}
                    asPath={processPath(asPath, 'path')}
                  >
                    <DamImage
                      className={`${className} carousel-image-new`}
                      imgConfigs={IMG_DATA_PLP_CAT_FILTERS.imgConfig}
                      imgData={{
                        alt: title,
                        url,
                      }}
                    />
                  </AnchorNew>
                  <div className="title-container-new">
                    <AnchorNew to={processPath(toPath, 'to')} asPath={processPath(asPath, 'to')}>
                      <BodyCopy
                        fontSize="fs16"
                        fontFamily="secondary"
                        textAlign="center"
                        fontWeight="semibold"
                        className={`multiline-ellipsis `}
                      >
                        {filterTitle?.toLowerCase()
                          ? filterTitle?.toLowerCase()
                          : title?.toLowerCase()}{' '}
                      </BodyCopy>
                    </AnchorNew>
                  </div>
                </div>
              </div>
            </AnchorNew>
          </div>
        );
      })
    );
  };

  getCarouselClassName = (categoryFilters, showPLPGenericCarousel, carouselClass) => {
    let newClass = carouselClass;
    if (showPLPGenericCarousel) {
      newClass += ' new-container';
    }
    return newClass;
  };

  renderDSKCaraosel = ({
    showPLPGenericCarousel,
    slidesToShow,
    carouselClass,
    SlickRight,
    SlickLeft,
    plpSbc,
    categoryFilters,
    className,
    asPath,
    carouselTitles,
  }) => {
    const { isSsrDone } = this.state;
    const [title1, title2, title3] = carouselTitles;
    const { isGenericSBCRedesignEnabled } = this.props;
    let containerClass = showPLPGenericCarousel ? 'item-container-new' : 'item-container';
    if (isGenericSBCRedesignEnabled) containerClass = '';
    return (
      <div className={`${containerClass} ${plpSbc ? 'sbc-plp' : ''}`}>
        <div className={carouselClass} ref={this.promoFilter}>
          <BodyCopy
            component="p"
            fontFamily="secondary"
            className={`sbc-heading ${isGenericSBCRedesignEnabled ? 'subheading' : ''}`}
          >
            {`${title1} ${title2} ${title3}`}
          </BodyCopy>

          <Carousel
            key={isSsrDone ? 'client' : 'server'}
            options={{
              className: 'slider desktop-carousel variable-width',
              variableWidth: false,
              autoplay: false,
              arrows: true,
              centerMode: false,
              fade: false,
              speed: 200,
              lazyLoad: false,
              dots: false,
              swipe: false,
              slidesToShow: isGenericSBCRedesignEnabled ? 8 : slidesToShow,
              slidesToScroll: 1,
              infinite: true,
              responsive: isGenericSBCRedesignEnabled
                ? getCarouselConfigResponsiveArray(categoryFilters.length, breakpoints)
                : getCarouselConfigArray(breakpoints, slidesToShow),
              prevArrow: <SlickLeft />,
              nextArrow: <SlickRight />,
              ref: this.carouselRef,
            }}
            carouselConfig={{
              autoplay: false,
            }}
          >
            {showPLPGenericCarousel && !isGenericSBCRedesignEnabled
              ? this.renderPlpGenericCarouselItems(
                  categoryFilters,
                  className,
                  'l3-nav-carousel-container-new',
                  asPath
                )
              : this.renderItems(categoryFilters, className, 'l3-nav-carousel-container', asPath)}
          </Carousel>
        </div>
      </div>
    );
  };

  renderPromoFilterItems = (
    categoryFilters,
    className,
    asPath,
    showPLPGenericCarousel,
    SlickRight,
    SlickLeft
  ) => {
    const { plpSbc, carouselTitle, isPromoForMobile, isGenericSBCRedesignEnabled } = this.props;
    const { isSsrDone } = this.state;
    const carouselTitles = carouselTitle?.toLowerCase().split(' ');
    const [title1, title2, title3] = carouselTitles;
    let carouselClass = 'container-carousel';
    carouselClass = this.getCarouselClassName(
      categoryFilters,
      showPLPGenericCarousel,
      carouselClass
    );

    const slidesToShow = getSlidesToShow(plpSbc);
    if (isSsrDone && (isDesktop || !isPromoForMobile)) {
      return (
        <>
          {this.renderDSKCaraosel({
            showPLPGenericCarousel,
            slidesToShow,
            carouselClass,
            SlickRight,
            SlickLeft,
            plpSbc,
            categoryFilters,
            className,
            asPath,
            carouselTitles,
          })}
        </>
      );
    }
    let containerClass = showPLPGenericCarousel ? 'item-container-new' : 'item-container';
    if (isGenericSBCRedesignEnabled) containerClass = '';

    const defaultCarousel = (
      <div className={containerClass}>
        <div className={carouselClass} ref={this.promoFilter}>
          <BodyCopy
            component="p"
            fontFamily="secondary"
            className={`sbc-heading ${isGenericSBCRedesignEnabled ? 'subheading' : ''}`}
          >
            {`${title1} ${title2} ${title3}`}
          </BodyCopy>
          <div className="sbc-mobile" ref={this.sbcWrappperRef}>
            {showPLPGenericCarousel && !isGenericSBCRedesignEnabled
              ? this.renderPlpGenericCarouselItems(
                  categoryFilters,
                  className,
                  'l3-nav-carousel-container-new',
                  asPath
                )
              : this.renderItems(categoryFilters, className, 'l3-nav-carousel-container', asPath)}
          </div>
        </div>
      </div>
    );

    if (isSsrDone && (!isDesktop || isPromoForMobile)) {
      return defaultCarousel;
    }

    return defaultCarousel;
  };

  formCustomStr = (L1, L2, L3) => {
    let str = `_${checkForCertainL1s(L1?.toLowerCase())}`;
    str += `_${L2 || 'na'}`;
    str += `_${L3 || 'na'}`;
    return str?.toLowerCase();
  };

  analyticCall = (direction) => {
    const { breadcrumb, plpSbc, trackHorizontalPlpAnalytic, isHPLP, isPLP } = this.props;
    let str;
    if (!trackHorizontalPlpAnalytic) return;
    let plpCategory = '';
    if (plpSbc) {
      plpCategory = breadcrumb?.[3]?.displayName;
    }
    if (isHPLP) {
      str = `${isHPLP}_na`;
    }
    if (isPLP) {
      str = `${isPLP}_na`;
    }
    const L2 = breadcrumb?.[2]?.displayName;
    const L1 = breadcrumb?.[1]?.displayName;
    trackHorizontalPlpAnalytic({
      internalCampaignId: `${str}${this.formCustomStr(L1, L2, plpCategory)}${direction}`,
      customEvents: ['event81'],
    });
  };

  clickRight = () => {
    this.carouselRef?.current?.slickNext();
    const direction = '_sbcscrollright';
    this.analyticCall(direction);
  };

  clickLeft = () => {
    this.carouselRef?.current?.slickPrev();
    const direction = '_sbcscrollleft';
    this.analyticCall(direction);
  };

  render() {
    const {
      categoryFilters,
      className,
      asPath,
      showCarousel,
      variation,
      showPLPGenericCarousel,
      isGenericSBCRedesignEnabled,
    } = this.props;
    const viewportObj = isClient() && getViewportInfo();

    const SlickLeft = () => {
      return <Button className="slick-prev" onClick={this.clickLeft} />;
    };

    const SlickRight = () => {
      return <Button className="slick-next" onClick={this.clickRight} />;
    };

    if (
      !showCarousel ||
      (variation === 'desktop' && !viewportObj.isDesktop) ||
      (variation === 'mobile' && viewportObj.isDesktop)
    ) {
      return null;
    }
    return (
      <div className={`${className} ${isGenericSBCRedesignEnabled ? 'sbc-redesign' : ''}`}>
        {this.renderPromoFilterItems(
          categoryFilters,
          className,
          asPath,
          showPLPGenericCarousel,
          SlickRight,
          SlickLeft
        )}
      </div>
    );
  }
}
export { L3NavigationCarousel as L3NavigationCarouselVanilla };
export default withStyles(L3NavigationCarousel, styles);
